import { useVLChatThread } from "../VLChat/VLChatWrapper";
import { App } from "antd";
import { useEffect, useState } from "react";

export const useFloatingHeader = () => {
  const { createNewThread } = useVLChatThread();
  const {
    modal: { confirm },
  } = App.useApp();
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    // assistant-ui Thread uses aui-thread-viewport class for the scrollable area
    const viewport = document.querySelector("[data-aui-thread-viewport]");
    if (!viewport) return;

    const handleScroll = () => setShowShadow(viewport.scrollTop > 0);
    viewport.addEventListener("scroll", handleScroll);
    return () => viewport.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNewChatClick = () => {
    confirm({
      title: "Create New Chat",
      content: "Are you sure? This will erase the current conversation.",
      okText: "Yes",
      cancelText: "No",
      onOk: () => createNewThread(),
      autoFocusButton: null,
    });
  };
  return {
    showShadow,
    handleNewChatClick,
  };
};
